// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingLayout_wrapper__sjD5H"};